import Vue from 'vue'
import { GetterTree, MutationTree } from "vuex"

import { getResource } from "~/utils/store"
import { RootState } from "~/store/store.types"

import { HousesState, HousesResource, House } from "./houses.types"

export const state = () => ({
  data: {},
  filters: {}
})

export const getters: GetterTree<HousesState, RootState> = {
  resourceById (state, _, __, rootGetters) {
    return (id: string, included: string | string[] = []) =>
      getResource<HousesResource>(state, id, rootGetters, included)
  },
}

export const mutations: MutationTree<HousesState> = {
  SET_HOUSE (state, hotel: House) {
    const { id } = hotel

    Vue.set(state.data, id, hotel)
  }
}
